module.exports = __webpack_public_path__ + "static/media/aniket.febf8c66.jpeg";